import Highcharts from 'highcharts';

export const figure52 = {
  chart: {
    zoomType: 'xy',
    animation: false,
    marginTop: 50,
    marginLeft: 300,
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'bar',
    backgroundColor: 'rgba(255, 255, 255, 0.0)',
    style: {
      fontFamily: 'Montserrat'
    }
  },

  colors: ['#5b9bd5'],

  credits: {
    enabled: false
  },
  title: {
    text: null
  },
  subtitle: {
    text: null
  },

  plotOptions: {
    series: {
      borderWidth: 0,
      marker: {
        symbol: 'circle',
        enabled: false,
        states: {
          hover: {
            enabled: true,
            radius: 5
          }
        }
      }
    }
  },

  exporting: {
    enabled: false
  },


  xAxis: [{
    categories: [
      "Mundo",
      "Asia occidental y África del Norte",
      "África subsahariana",
      "Oceanía (excepto Australia y Nueva Zelanda)",
      "América del Norte y Europa",
      "América Latina y el Caribe",
      "Asia oriental y Asia sudoriental",
      "Asia Central y Asia Meridional",
      "Australia y Nueva Zelanda"
    ],
    lineColor: "#d7d7d7",
    tickColor: "#d7d7d7",
    tickLength: 16,
    labels: {

      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      }
    },
  }],
  yAxis: [{ // Primary yAxis
    labels: {
      //format: '{value}%',
      format: '{value}',
      style: {
        fontWeight: 'normal',
        color: '#999999',
        fontSize: '12px'
      },
    },
    gridLineWidth: 2,
    max: 100,
    min: 0,
    tickInterval: 20,
    title: {
      text: null,
      style: {
        color: Highcharts.getOptions().colors[1]
      }
    }
  }],
  tooltip: {
    shared: true,
    useHTML: true,
    hideDelay: 500,
    backgroundColor: null,
    borderWidth: 0,
    shadow: false,
    style: {
      padding: 0
    }
  },
  legend: {
    enabled: false,
  },

  series: [{
    name: 'Índice de cobertura verde de las montañas por región, 2018',
    tooltip: {
      valueSuffix: '%'
    },
    dataLabels: {
      enabled: false,
      style: {
        fontWeight: 'normal',
        textOutline: false,
        color: '#999999',
        fontSize: '12px'
      }

    },
    data: [
        {y: 73.1839153, color: '#ed7d31'},
        {y: 55.13824972, color: '#5b9bd5'},
        {y: 92.24774246, color: '#5b9bd5'},
        {y: 99.33245127, color: '#5b9bd5'},
        {y: 65.82934909, color: '#5b9bd5'},
        {y: 81.37669205, color: '#5b9bd5'},
        {y: 85.02956643, color: '#5b9bd5'},
        {y: 66.29996646, color: '#5b9bd5'},
        {y: 94.06825425, color: '#5b9bd5'}
    ]
  }]

};